import { UploadZone } from "@components:UploadZone";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FieldLabel } from "./shared-styles";

interface LogoUploadZoneProps {
  logoPreview: string | null;
  onUpload: (file: File) => void;
  onRemove: () => void;
  error?: string;
}

export const LogoUploadZone = ({
  logoPreview,
  onUpload,
  error,
}: LogoUploadZoneProps) => {
  const { t } = useTranslation();
  return (
    <Box>
      <FieldLabel>{t("preferences.uiBranding.logo")}</FieldLabel>
      <UploadZone
        size="small"
        onFileSelect={onUpload}
        selectedFile={null}
        previewUrl={logoPreview}
        accept="image/png,image/jpeg,image/svg+xml,image/webp"
        title={t("preferences.uiBranding.logoDropTitle")}
        subtitle={t("preferences.uiBranding.logoFormats")}
        hint={t("preferences.uiBranding.logoHint")}
      />
      {error && (
        <Typography variant="caption" color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};
